import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Grid, Typography } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import { SectionTitle } from '../../components/SectionTitle';
import HelpSchedaBudgetForfetario from './HelpSchedaBudgetForfetario';
import HelpSchedaBudgetImpresa from './HelpSchedaBudgetImpresa';
import HelpSchedaBudgetProfessionista from './HelpSchedaBudgetProfessionista';

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {
//       width: '100%',
//     },
//     heading: {
//       fontSize: theme.typography.pxToRem(15),
//       fontWeight: theme.typography.fontWeightRegular,
//     },
//   }),
// );

export default function HelpSchedaBudget(props: any) {
    //const classes = useStyles();
    return (
            <Grid container justify="flex-start" alignItems="flex-start" direction="column" style={{ minHeight: "90vh", width: "95vw", marginTop: "1vh" }}>
                <ExpansionPanel>
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <SectionTitle text="Imprese"></SectionTitle>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Typography>
                            <HelpSchedaBudgetImpresa></HelpSchedaBudgetImpresa>
                        </Typography>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel>
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <SectionTitle text="Professionisti"></SectionTitle>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Typography>
                            <HelpSchedaBudgetProfessionista></HelpSchedaBudgetProfessionista>
                        </Typography>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel>
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <SectionTitle text="Regime fiscale forfetario"></SectionTitle>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Typography>
                            <HelpSchedaBudgetForfetario></HelpSchedaBudgetForfetario>
                        </Typography>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </Grid>
        );
}